import React from 'react'
import { Asset } from 'contentful'
import { IEntry, IImage as IContentfulImage } from 'marketing-site/@types/generated/contentful'
import { Image, IProps as IImage } from 'marketing-site/src/library/elements/Image'
import EntryMarker from 'marketing-site/src/components/common/EntryMarker'

export function isImage(entry: IEntry): entry is IContentfulImage {
  return entry.sys.contentType?.sys.id === 'image'
}

export const ContentfulImage = (image: IContentfulImage): React.ReactElement => {
  return <EntryMarker entry={image}>{() => <Image {...transformImage(image)} />}</EntryMarker>
}

export function transformImage({ fields }: IContentfulImage): IImage {
  return {
    ...fields,
    url: fields.image.fields.file.url,
    width: fields.image.fields.file.details.image?.width,
    height: fields.image.fields.file.details.image?.height,
    hasRoundedCorners: fields.hasRoundedCorners && fields.hasRoundedCorners,
  }
}

export function transformAssetToImage({ fields }: Asset): IImage {
  return {
    url: fields.file.url,
    width: fields.file.details.image?.width,
    height: fields.file.details.image?.height,
  }
}
